var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import { BV2 } from "../../utils/vector.js";
import "../types.js";
import { N as NoLocomotionSchema } from "../../NoLocomotion-8fddd32b.js";
import { L as LocomotionSchema } from "../../Locomotion-379972de.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
class NoLocomotionSystem {
  constructor() {
    __publicField(this, "type", "NoLocomotion");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", NoLocomotionSchema);
    __publicField(this, "depth", DEPTHS.LOCOMOTION - 1e-7);
  }
  runAll(gameModel) {
    const entities = gameModel.getComponentActives("NoLocomotion");
    for (let i = 0; i < entities.length; ++i) {
      const entity = entities[i];
      const locomotionSchema = gameModel.getTypedUnsafe(entity, LocomotionSchema);
      locomotionSchema.decayingVelocityX = 0;
      locomotionSchema.decayingVelocityY = 0;
      if (locomotionSchema.velocityX || locomotionSchema.velocityY) {
        const direction = BV2.normalizeVector2d(locomotionSchema.velocityX, locomotionSchema.velocityY);
        locomotionSchema.directionX = direction[0];
        locomotionSchema.directionY = direction[1];
        locomotionSchema.velocityX = 0;
        locomotionSchema.velocityY = 0;
      }
      locomotionSchema.decayingVelocityTime = 0;
    }
  }
}
registerSystem(NoLocomotionSystem);
//# sourceMappingURL=NoLocomotion.js.map
